import Header from "../components/header";
import LoginForm from "../components/login-form";
import LeftAlignedText from "../components/left-aligned-text";
import TwoGrid from "../components/two-grid";

function LoginPage(){
    const sendToSignup = () => {
        window.location.href = '/signup';
    }
    return <>
    <Header URLForLogo='/' CTA='Sign up' functionForButton={sendToSignup}></Header>
    <TwoGrid item2={<LoginForm></LoginForm>} item1={<LeftAlignedText heading='Start your journey with Mako' text='Mako crawls your inputs, alerts you to new posts and helps you create limitless content ideas with one click.'></LeftAlignedText>}></TwoGrid>
   
    </>
}
    
export default LoginPage;